/**
 * BannerDetailContainer
 * --
 */
import React from 'react';
import BannerDetailPresenter from './BannerDetailPresenter';

const BannerDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BannerDetailPresenter />
    </>
  );
};

export default BannerDetailContainer;
